export type PrinciplePoint = { title: string; body: string };
export type Principle = {
  title: string;
  kicker: string;
  image: string;
  href: string;
  points: PrinciplePoint[];
};

/** Order: Culture (featured), Capital, Longevity. */
export const principles: Principle[] = [
  {
    title: 'Culture',
    kicker: 'Authority that attracts the right people and opportunities.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/4af6c1b3-9315-4362-aabe-b081067f5496.jpg',
    href: '#ecosystem',
    points: [
      { title: 'Lifestyle media', body: '1.1M+ followers giving the ecosystem cultural reach.' },
      { title: 'Private communities', body: '320,000+ members and a private club for operators.' },
      { title: 'Brand intelligence', body: 'Visual identity that turns substance into quiet authority.' },
      { title: 'Curated network', body: 'Introductions earned through shared standards, never bought.' },
    ],
  },
  {
    title: 'Capital',
    kicker: 'Curated, never accumulated. Wealth qualified and scaled with intent.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/82d74f7d-34f7-417c-833d-1e4f5f358aa6.jpg',
    href: '#ecosystem',
    points: [
      { title: 'Off-market real estate', body: 'Early access to developments in Dubai, Mallorca and Poland.' },
      { title: 'Equity infrastructure', body: 'A qualified bridge from CEE developers to DACH capital.' },
    ],
  },
  {
    title: 'Longevity',
    kicker: 'Clarity, health and duration — the baseline of all wealth.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/8474d641-f693-4533-b273-b606713c0968.jpg',
    href: '#ecosystem',
    points: [
      { title: 'NeuroPerformance', body: 'Systems for peak cognitive and physical state.' },
      { title: 'Curated retreats', body: 'Retreats built to restore time and mental space.' },
    ],
  },
];

export const snapshot: { label: string; value: string }[] = [
  { label: 'Entity', value: 'KAYS & KAYS · Dubai, UAE · MMXXVI' },
  { label: 'Founder & Architect', value: 'Adrian Kays' },
  { label: 'Combined Media Reach', value: '1.4M+ global & DACH audience' },
  { label: 'Asset Focus', value: 'Off-market real estate, equity infrastructure, NeuroPerformance, private communities' },
  { label: 'Primary Markets', value: 'Dubai, DACH (Germany, Austria, Switzerland), CEE (Poland), global hubs' },
];
